module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.save
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": this.settings.title
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-747afc63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/InputDialog.vue
// module id = 2604
// module chunks = 1